import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import { AWARDS_API_PREFIX } from './awardsApiBase';

export interface ISubmitBidApplicationParams {
  cycleId: string;
  answers: Record<string, string>;
  mailingAddress: string;
  termsAccepted: boolean;
}

/**
 * Backend expects `answers`, `mailingAddress`, and `termsAccepted` as
 * top-level body fields; `cycleId` goes in the URL path. `officeId` overrides
 * the `x-office` header, so a location's application is filed for it.
 */
export const submitBidApplication = async (
  params: ISubmitBidApplicationParams,
  officeId?: string,
): Promise<void> => {
  const { cycleId, ...body } = params;
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.post(`${AWARDS_API_PREFIX}/cycles/${cycleId}/applications`, body, { headers });
};
